import React from "react";
import { Alert as BootAlert } from "reactstrap";

export interface AlertProps {
    children?: React.ReactNode;
    className?: string;
    style?: "info" | "error" | "success";
}

export const Alert = ({ children, className, style = "info" }: AlertProps) => {
    let color = "info";
    switch (style) {
        case "error":
            color = "danger";
            break;
        case "success":
            color = "success";
            break;
    }
    return (
        <BootAlert color={color} className={className}>{children}</BootAlert>
    );
};
